import { Button } from "react-bootstrap";
import { api } from "./pureFunctions";
import axios from "axios";

export default function MyTest({}) {
   async function asyncButton() {
      const reqData = {
         recipient: {
            comment_id: "18125146663732849",
         },
         message: {
            text: "Hallo! Hier ist der gewünschteme",
         },
         access_token:
            "IGAAjaGLLTx1pBZAFo0MHFNWndfSi12RzlnTGR4SlY2WlFRTlJTWHFPWHN0dlFIZA1pSTnlydHFJUWlTZAmFhcEZAmelZAmMTVtMHgtNE4xQkh5bTFLS0RKZAV9vcDFaRDFCbm1yUlA0N0VobUZAleWJLWV85bGg1MnE0OC03QVN1NkpwbwZDZD",
      };

      await axios.post("https://graph.instagram.com/v25/me/messages", reqData)
         .then((data) => {
            console.log(data);
         })
         .catch((err) => {
            console.log(err);
         });
   }

   return (
      <div className="m-5">
         <Button
            onClick={async () => {
               asyncButton();
            }}
         >
            Test
         </Button>
      </div>
   );
}
